import { styled, Typography } from "@material-ui/core"

export const ErrorText = styled(Typography)({
  fontSize: 14,
  color: "red"
})
